import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import helpersTime from "../../../../../helpers/time";
import Pagination from "../../../../partials/content/Pagination";
import MobileHelper from "../../../../../helpers/mobile";
import typeCollaboration from "./type-collaboration";

export default function ViewMarketer() {
  const params = useParams();
  const userMarketerID = params.id;
  const [userMarketer, setUserMarketer] = useState();

  useEffect(() => {
    getUserMarketer();
  }, []);

  const getUserMarketer = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const userMarketer = await sendRequestGetUserMarketer(userMarketerID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!userMarketer) {
      return;
    }
    setUserMarketer(userMarketer);
  };

  const sendRequestGetUserMarketer = async (userID) => {
    const headersRequest = getHeaderForRequest();
    let user;
    try {
      user = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/marketer/manage/${userID}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return user.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar openItem="users" activeItem="all-marketer" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">همه کاربران بازاریاب</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link to="/user/marketer/all" className="btn btn-primary">
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {userMarketer && (
                <div className="table-responsive pt-2">
                  <table className="table table-hilite tbl-td-white-space table-hover m-0">
                    <thead>
                      <tr>
                        <td
                          colSpan={2}
                          className="text-center"
                          style={{ borderRadius: "25px 25px 0 0" }}
                        >
                          اطلاعات بازاریاب
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>شماره کاربری</td>
                        <td>{userMarketer.mar_user_id}</td>
                      </tr>
                      <tr>
                        <td>شناسه کاربری</td>
                        <td>{userMarketer.mar_identity_marketer}</td>
                      </tr>
                      <tr>
                        <td>شماره موبایل</td>
                        <td dir="ltr">
                          {helpersNumber.toPersianNum(
                            MobileHelper.formatMobile(userMarketer.mobile)
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>نام</td>
                        <td>{userMarketer.first_name}</td>
                      </tr>
                      <tr>
                        <td>نام خانوادگی</td>
                        <td>{userMarketer.last_name}</td>
                      </tr>
                      <tr>
                        <td>درصد اولیه</td>
                        <td>{userMarketer.mar_first_percent}</td>
                      </tr>
                      <tr>
                        <td>درصد دائمی</td>
                        <td>{userMarketer.mar_permanent_percent}</td>
                      </tr>
                      <tr>
                        <td>نوع همکاری</td>
                        <td>
                          {
                            typeCollaboration.getTypeCollaborationString()[
                              userMarketer.mar_type_collaboration
                            ]
                          }
                        </td>
                      </tr>
                      <tr>
                        <td>تعداد درصد دائمی</td>
                        <td>{userMarketer.mar_count_permanent_percent}</td>
                      </tr>
                      <tr>
                        <td>وضعیت</td>
                        <td>
                          {userMarketer.mar_active ? (
                            <span class="badge badge-success">فعال</span>
                          ) : (
                            <span class="badge badge-danger">غیرفعال</span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>تاریخ ثبت نام</td>
                        <td>
                          {helpersNumber.toPersianNum(
                            helpersTime.convertGregorianToJalali(
                              userMarketer.mar_created_at
                            ) +
                              " " +
                              userMarketer.mar_created_at.split(" ")[1]
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>تاریخ آخرین بروزرسانی</td>
                        <td>
                          {helpersNumber.toPersianNum(
                            helpersTime.convertGregorianToJalali(
                              userMarketer.mar_updated_at
                            ) +
                              " " +
                              userMarketer.mar_updated_at.split(" ")[1]
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>اطلاعات بیشتر کاربر</td>
                        <td>
                          <Link
                            to={`/user/show-info-user/${userMarketerID}`}
                            className="btn btn-primary"
                            target={"_blank"}
                          >
                            <span>
                              <i className="fa fa-eye"></i>
                            </span>
                          </Link>
                        </td>
                      </tr>
                      <tr>
                        <td>لیست تغییرات</td>
                        <td>
                          <Link
                            to={`/user/marketer/edit/all-log/${userMarketerID}`}
                            className="btn btn-primary"
                            target={"_blank"}
                          >
                            <span>
                              <i className="fa fa-eye"></i>
                            </span>
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
